/**
 * Turns "spaced" string into camel case.
 * @param str - String to make camel case.
 */
export function toCamelCase(str: string): string {
    return str[0].toLowerCase() + str.slice(1).replace(/ /g, "");
}
